

const sleep = msec =>
  new Promise(resolve => setTimeout(resolve, msec))

const addCss = () => {
  const style = document.createElement('style')
  style.id = 'anygift-custom-css'
  style.innerHTML =  '.additional-checkout-buttons { display: none !important; }'
  document.body.appendChild(style)
}

const removeCss = () => {
  const style = document.getElementById('anygift-custom-css')
  if (style) {
    document.body.removeChild(style)
  }
}


const searchGiftOptionElement = async () => {
   for (let i = 0; i < 40; i++) {
      const giftOptionElement = document.querySelectorAll('.anygift-option-button__circle')[1]
      if (giftOptionElement) {
          return giftOptionElement
      }
      await sleep(200)
  }
  return null
}


searchGiftOptionElement().then((giftOptionElement) => {
  if (giftOptionElement) {
    const giftOptionObserver = new MutationObserver((mutations) => {
      mutations.forEach((value) => {
        const isGiftSelected = Array.from(value.target.classList).includes('anygift-option-button__circle-active')

        if (isGiftSelected) {
          addCss()
        } else {
          removeCss()
        }
      });
    });

    const observerConfig = {
      childList: false,
      attributes: true,
      characterData: false,
      subtree: false,
    };

    giftOptionObserver.observe(giftOptionElement, observerConfig)
  }
})


fetch('/cart.js').then(
    async cart => {
        const res = await cart.json()
        const isGiftEnabledItemInCart = res.items.some(item =>
            item.properties &&
                'ギフト購入' in item.properties &&
                item.properties['ギフト購入'] === '有効',
        )
        if (isGiftEnabledItemInCart) {
          addCss()
        } else {
          removeCss()
        }                                        
    },
    error => {
        console.log(`cart.js 読み込み失敗 ${error.message}`);
    }
);